ui-bank-search-light {
  background-color: $sd-backgroundColor-neutral-100;
  padding: $sd-spacing-6 0 $sd-spacing-10;
  display: block;
  container-type: inline-size;

  & > ui-bank-search-autocomplete,
  & > h3 {
    margin: 0 $sd-spacing-10;
  }

  ui-cms-image {
    margin-bottom: $sd-spacing-5;
  }

  ui-bank-search-autocomplete {
    margin-bottom: 30px;
  }

  & > ui-bank-search-list,
  .results-title {
    margin-bottom: $sd-spacing-4;
  }

  & > sd-button {
    width: calc(100% - $sd-spacing-20);
    margin: 0 $sd-spacing-10;

    @container (min-width: #{$small}) {
      width: auto;
      margin: 0 0 0 50%;
      transform: translateX(-50%);
    }
  }
}
